import React, { type FC } from 'react'

import useCompanyParam from 'hooks/CompanyParam'
import { useInfiniteQueryDataFetcher } from 'hooks/useInfiniteQueryDataFetcher/useInfiniteQueryDataFetcher'
import { channelSelector } from 'redux-store/channel/channel.selectors'
import { useAppSelector } from 'redux-store/hooks'
import { fetchFeeds } from '../../api/fetchFeeds'
import { FeedData, FeedQueryParams } from '../../types'
import { CardList } from '../card/CardList/CardList'
import { CardSkeleton } from '../card/CardSkeleton/CardSkeleton'
import useInfiniteScroll from 'hooks/useInfiniteScroll/useInfiniteScroll'

import classes from './ContentContainer.module.scss'

type ContentContainerProps = {
  queryKey?: string
}

export const ContentContainer: FC<ContentContainerProps> = ({
  queryKey = 'soloQuery'
}) => {
  const channel = useAppSelector(channelSelector)
  const company = useCompanyParam()

  const apiToUse = (params: FeedQueryParams) => {
    if (company && channel.data) {
      return fetchFeeds({
        page: params.page,
        per_page: params.per_page,
        company: params.company
      })
    }
    if (channel.data.isRootChannel) {
      return fetchFeeds({
        page: params.page,
        per_page: params.per_page,
        company: params.company
      })
    }
    return fetchFeeds({
      page: params.page,
      per_page: params.per_page,
      company: params.company,
      country_code: params.country_code,
      sport: params.sport
    })
  }

  const queryParameters: FeedQueryParams = {
    company: company,
    country_code: channel?.data?.country.code,
    sport: channel?.data?.category?.translated_name,
    per_page: 10,
    page: 1,
    channel: channel
  }
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQueryDataFetcher<FeedQueryParams, FeedData>({
      queryKey: `${queryKey}-feedContentData`,
      queryFn: apiToUse,
      params: queryParameters,
      perPage: queryParameters.per_page
    })

  const loadMoreRef = useInfiniteScroll({
    fetchNextPage,
    hasNextPage,
    isLoading: isFetchingNextPage
  })

  return (
    <div className={classes.Container}>
      <CardList items={data} isLoading={isLoading} />
      {hasNextPage && (
        <div ref={loadMoreRef}>
          <CardSkeleton />
        </div>
      )}
    </div>
  )
}
